import React, { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import { SeoHead } from 'components';
import { RouteNames } from '../../constants';
import CouponList from './CouponList';

const ReservedCouponsList = props => {
  const navigate = useNavigate();
  const now = new Date();

  const filterFunction = coupon => {
    const expiryDate = new Date(coupon.expiry_time);
    return coupon.state === 'reserved' && expiryDate > now;
  };

  const handleCouponPress = useCallback(
    applyCoupon => {
      if (applyCoupon?.coupon) {
        navigate(RouteNames.COUPONS_RESERVED, { state: { reservedData: applyCoupon } });
      }
    },
    [navigate],
  );

  return (
    <>
      <SeoHead title="Reserved Coupons" noIndex />
      <CouponList {...props} filterFunction={filterFunction} onCouponPress={handleCouponPress} enableButton />
    </>
  );
};

export default ReservedCouponsList;